import { jsx as _jsx } from "react/jsx-runtime";
import { useLocalizeMessage, Table } from 'libs.nucleus';
import { useUserReportTableColumn } from './user_reports_table_columns.hook';
export const UserReportsTable = ({ data, isLoading }) => {
    const translate = useLocalizeMessage();
    const { reportColumns } = useUserReportTableColumn();
    return (_jsx(Table, { columns: reportColumns, data: data || [], hasPagination: true, initialPageSize: 10, isLoading: isLoading, labelNoResults: translate('No user reports'), paginationNavigationScreenReaderLabel: translate('User reports table'), useInternalSearch: true, labelSearchField: translate('Search') }));
};
